<template>
  <ul class="folder-data__nav">
    <FolderItem
      class="result"
      ref="filderItems"
      v-bind="folder"
      :checked="folderIsChecked(folder._id)"
      @check="toggleFolder(folder)"
      :key="folder._id"
      v-for="folder of sortedFolders"
    ></FolderItem>
    <FolderItem
      class="result"
      ref="filderItems"
      v-bind="podcast"
      :checked="podcastIsChecked(podcast._id)"
      @check="togglePodcast(podcast)"
      :filter="filter"
      :key="podcast._id"
      v-for="podcast of sortedPodcasts"
    ></FolderItem>
  </ul>
</template>

<script>
import FolderItem from '@/components/FolderItem.vue'

export default {
  components: {
    FolderItem,
  },

  props: {
    folders: {
      type: Array,
      default: () => [],
    },
    podcasts: {
      type: Array,
      default: () => [],
    },
    selectAll: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sortedFolders() {
      if (!this.sortMode) {
        return this.folders
      }

      return this.folders.slice().sort((a, b) => {
        if (this.sortMode === 'asc') {
          return a.createdAt - b.createdAt
        }

        return b.createdAt - a.createdAt
      })
    },
    sortedPodcasts() {
      if (!this.sortMode) {
        return this.podcasts
      }

      return this.podcasts.slice().sort((a, b) => {
        if (this.sortMode === 'asc') {
          return a.createdAt - b.createdAt
        }

        return b.createdAt - a.createdAt
      })
    },
    sortMode() {
      return this.$store.state.folders.sortMode
    },
    filter() {
      return this.$route.query.status
    },
    checkedFolders() {
      return this.$store.state.folders.checkedFolders
    },
    checkedPodcasts() {
      return this.$store.state.folders.checkedPodcasts
    },
  },

  watch: {
    selectAll(checked) {
      this.folders.forEach(({ _id }) => {
        if (checked) {
          this.$store.commit('folders/addFolder', _id)
        } else {
          this.$store.commit('folders/removeFolder', _id)
        }
      })

      this.podcasts.forEach(({ _id }) => {
        if (checked) {
          this.$store.commit('folders/addPodcast', _id)
        } else {
          this.$store.commit('folders/removePodcast', _id)
        }
      })
    },
  },

  beforeDestroy() {
    this.$store.commit('folders/disableSelectMode')
  },

  methods: {
    toggleFolder(item) {
      this.$store.commit('folders/toggleFolder', item._id)
    },
    togglePodcast(item) {
      this.$store.commit('folders/togglePodcast', item._id)
    },
    folderIsChecked(id) {
      return this.checkedFolders.some(itemId => itemId === id)
    },
    podcastIsChecked(id) {
      return this.checkedPodcasts.some(itemId => itemId === id)
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-data {
  @include e(item) {
    @apply border-t border-solid border-gray-400;
  }
}
</style>
